module.exports = __webpack_public_path__ + "static/media/IMG_3439-min.80a8ebe7.jpg";